import { render, staticRenderFns } from "./IpAlert.vue?vue&type=template&id=c3b319e6&scoped=true"
import script from "./IpAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./IpAlert.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IpAlert.vue?vue&type=style&index=0&id=c3b319e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b319e6",
  null
  
)

export default component.exports